import { useEffect } from "react";
import { useContent } from "@/contexts/ContentContext";
import { resolveUploadUrl } from "@/lib/api";

/** Synchronises <title> + meta tags with the live `content.seo`.
 * Mounted once near the top of the public page tree.
 */
const setMeta = (selector, attr, value) => {
    if (!value) return;
    let el = document.head.querySelector(selector);
    if (!el) {
        el = document.createElement(selector.startsWith("meta") ? "meta" : "link");
        // Add attributes from the selector hint, e.g. meta[name="description"]
        const m = selector.match(/\[(\w+)="([^"]+)"\]/);
        if (m) el.setAttribute(m[1], m[2]);
        document.head.appendChild(el);
    }
    el.setAttribute(attr, value);
};

export const SeoHead = () => {
    const { content } = useContent();
    const seo = content.seo || {};

    useEffect(() => {
        if (seo.title) document.title = seo.title;
        if (seo.description) setMeta('meta[name="description"]', "content", seo.description);
        if (seo.og_title) setMeta('meta[property="og:title"]', "content", seo.og_title);
        if (seo.og_description) setMeta('meta[property="og:description"]', "content", seo.og_description);
        const ogImage = resolveUploadUrl(seo.og_image_url);
        if (ogImage) setMeta('meta[property="og:image"]', "content", ogImage);
    }, [seo.title, seo.description, seo.og_title, seo.og_description, seo.og_image_url]);

    return null;
};

export default SeoHead;
